import http from './http';

// 房型列表
export const fetchRoomTypeList = () => {
  return http({
    url: '/rooms/types/list',
  });
};

// 房型管理（包含房间信息）
export const fetchRoomTypeQuery = () => {
  return http({
    url: '/rooms/types/query',
  });
};

// 修改房型
export const fetchUpdateRoomType = (data) => {
  return http({
    method: 'PUT',
    url: '/rooms/types',
    data,
  });
};

// 楼层列表
export const fetchFloorList = () => {
  return http({
    url: '/floor/list',
  });
};

export const fetchUpdateFloor = (data) => {
  return http({
    method: 'PUT',
    url: '/floor',
    data,
  });
};

// 房间列表
export const fetchRoomsList = () => {
  return http({
    url: '/rooms/query',
  });
};

export const fetchUpdateRooms = (data) => {
  return http({
    method: 'PUT',
    url: '/rooms',
    data,
  });
};

// 房间标签
export const getRoomTagList = () => {
  return http({
    method: 'GET',
    url: '/room-tag/list',
  });
};
